import { api } from '@/api/client'
import type { Item } from '@/types/models'
import { ListPickerModal } from './ListPickerModal'

interface Props {
  value: number | null
  onChange: (it: Item) => void
  placeholder?: string
  /** 이미 아는 라벨(예: 매핑 행의 '코드 품명'). 주면 마운트 시 개별 상세조회 생략. */
  initialLabel?: string
}

export function ItemPicker({ value, onChange, placeholder = '품목 선택...', initialLabel }: Props) {
  return (
    <ListPickerModal<Item>
      value={value}
      onChange={onChange}
      initialLabel={initialLabel}
      title="품목 선택"
      triggerPlaceholder={placeholder}
      searchPlaceholder="품목코드, 품명"
      queryKey={['items-picker']}
      fetchDetail={(id) => api<Item>(`/api/items/${id}`)}
      fetchList={(q) => {
        const params = new URLSearchParams()
        if (q) params.set('q', q)
        const qs = params.toString()
        return api<Item[]>(`/api/items${qs ? `?${qs}` : ''}`)
      }}
      formatLabel={(it) => `${it.code} ${it.name}`}
      renderRow={(it) => (
        <>
          <span className="font-mono text-xs text-slate-500 tabular-nums mr-2">{it.code}</span>
          <span>{it.name}</span>
          {it.spec && <span className="text-xs text-slate-400 ml-2">{it.spec}</span>}
          {it.unit_out && (
            <span className="text-xs text-slate-500 ml-2 px-1.5 py-0.5 bg-slate-100 rounded">
              {it.unit_out}
            </span>
          )}
        </>
      )}
    />
  )
}
